export const DEFAULT_PAGE_SIZE = 10;

export const CATERING_TYPE_BREAKFAST = 'Breakfast';
export const CATERING_TYPE_LUNCH = 'Lunch';
export const CATERING_TYPE_DINNER = 'Dinner';
export const CATERING_TYPE_DRINKS_AND_EXTRAS = 'DrinksAndExtras';
export const CATERING_TYPES = [
    CATERING_TYPE_BREAKFAST,
    CATERING_TYPE_LUNCH,
    CATERING_TYPE_DINNER,
    CATERING_TYPE_DRINKS_AND_EXTRAS,
] as const;
export type CateringType = (typeof CATERING_TYPES)[number];

export const PARTNER_TYPE_REFERRAL = 'REFERRAL';
export const PARTNER_TYPE_ACTIVITY = 'ACTIVITY';
export const PARTNER_TYPES = [PARTNER_TYPE_REFERRAL, PARTNER_TYPE_ACTIVITY] as const;

export const PARTNER_STATUSES = ['PENDING', 'ACTIVE', 'DISABLED'] as const;

export const PARTNERSHIP_AGREEMENT_SIGNATURE_STATUSES = ['SIGNED', 'DECLINED'] as const;

/** Non-exhaustive list of `db.accounts.providerId` variants. */
export const ACCOUNT_PROVIDER_IDS = ['credential', 'federation.funkey.be'] as const;
